import SaveRecipe from "@/components/SaveRecipe";
import SaveRecipeToShoppingList from "@/components/SaveRecipeToShoppingList";
import SignUpCTAButton from "@/src/recipes/components/RecipeHero/SignUpCTAButton";
import { Recipe } from "@/types/recipe";
import clsx from "clsx";
import { useFeatureFlagVariantKey } from "posthog-js/react";

const RecipeActions = ({
  entry,
  isMobPlusMember = true,
}: {
  entry: Recipe;
  isMobPlusMember?: boolean;
}) => {
  // A/B testing for recipe hero trial CTA
  const recipeHeroTrialCtaVariant = useFeatureFlagVariantKey(
    "cro-web-147-shopping-list-to-free-users-paywall"
  );

  // DEBUG: Log the variant value (not in production)
  if (process.env.NEXT_PUBLIC_VERCEL_ENV !== "production") {
    console.log("🧪 Feature flag variant:", recipeHeroTrialCtaVariant);
  }

  // TEMP: Override for testing (remove after debugging)
  // const recipeHeroTrialCtaVariant = "control"; // or "with-recipe-hero-trial-cta"

  // Determine if we should show the CTA button
  const shouldShowCTA =
    !isMobPlusMember &&
    recipeHeroTrialCtaVariant === "with-recipe-hero-trial-cta";

  // For free users in control variant, show only CTA
  if (!isMobPlusMember && recipeHeroTrialCtaVariant === "control") {
    return <SignUpCTAButton componentLocation="details_panel_desktop" />;
  }

  // For free users in without-recipe-hero-trial-cta variant, show recipe buttons only (no CTA)
  // This is the same as default behavior, but explicit for clarity

  return (
    <div
      className={clsx(
        // Mobile: strict grid layout (always 2 columns)
        "grid grid-cols-2 gap-3",
        // Desktop: flex layout with natural sizing
        "sm:flex sm:items-center sm:gap-3 lg:gap-3"
      )}
    >
      {/* Save Recipe Button */}
      <SaveRecipe
        recipe={entry}
        theme={"dark"}
        size="lg"
        showLabel
        border
        className="w-full sm:w-auto"
      />

      {/* Shopping List Button */}
      <SaveRecipeToShoppingList
        recipe={entry}
        variant="button"
        className="w-full sm:w-auto"
      />

      {/* CTA button for A/B test variant */}
      {shouldShowCTA && (
        <div className="col-span-2 sm:col-span-1">
          <SignUpCTAButton
            componentLocation="details_panel_desktop"
            className="w-full sm:w-auto"
          />
        </div>
      )}
    </div>
  );
};

export default RecipeActions;
